import React, { useEffect } from "react";
import HostNav from "../components/hostComponents/HostNav";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { getFlags, getHostProperties } from "../store/thunks/hostActions";
import PmsConnectionPanel from "../components/onboarding/PmsConnectionPanel";
import EntryInstructionEmailPreference from "../components/onboarding/EntryInstructionEmailPreference";

const INTEGRATIONS_TOAST_STORAGE_KEY = "pending_integration_toast";

const IntegrationsScreen = () => {
  const dispatch = useDispatch();
  const { hostInfo } = useSelector((state) => state.host);
  const { properties } = useSelector((state) => state.hostProperties);

  useEffect(() => {
    const pendingToastRaw = sessionStorage.getItem(INTEGRATIONS_TOAST_STORAGE_KEY);
    if (!pendingToastRaw) return;
    sessionStorage.removeItem(INTEGRATIONS_TOAST_STORAGE_KEY);
    try {
      const pendingToast = JSON.parse(pendingToastRaw);
      if (pendingToast?.type === "success") {
        toast.success(pendingToast.message || "Integration updated.");
      } else if (pendingToast?.type === "error") {
        toast.error(pendingToast.message || "Integration update failed.");
      }
    } catch (_) {
      /* ignore malformed session values */
    }
  }, []);

  useEffect(() => {
    if (hostInfo?._id) {
      dispatch(getFlags(hostInfo._id));
      dispatch(getHostProperties(hostInfo._id));
    }
  }, [dispatch, hostInfo?._id]);

  const refreshProperties = () => {
    if (!hostInfo?._id) return Promise.resolve();
    return dispatch(getHostProperties(hostInfo._id));
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-6 py-8">
        <HostNav hide={true} />

        <div className="mb-8 flex flex-wrap items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Integrations</h1>
            <p className="mt-1 text-gray-500">Connect your property management software to sync your properties.</p>
          </div>
          <Link
            to="/properties"
            className="flex items-center space-x-2 rounded-xl bg-gray-900 px-5 py-2.5 text-sm font-medium text-white transition-all duration-200 hover:bg-gray-800"
          >
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span>Back to Properties</span>
          </Link>
        </div>

        <div className="space-y-5">
          <PmsConnectionPanel
            hostInfo={hostInfo}
            properties={properties}
            onPropertiesRefresh={refreshProperties}
          />
          <EntryInstructionEmailPreference
            hostId={hostInfo?._id}
            title="Entry instruction emails"
            description="Bellhopt will email the recipient list below when an order needs entry instructions or delivery timing context."
            footerLink={{ href: `/settings/${hostInfo?._id}`, label: "Profile Settings" }}
          />
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default IntegrationsScreen;
